import { render, staticRenderFns } from "./FlightDetailsInfo.vue?vue&type=template&id=5169b548&scoped=true&"
import script from "./FlightDetailsInfo.vue?vue&type=script&lang=js&"
export * from "./FlightDetailsInfo.vue?vue&type=script&lang=js&"
import style0 from "./FlightDetailsInfo.vue?vue&type=style&index=0&id=5169b548&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5169b548",
  null
  
)

export default component.exports